// extracted by mini-css-extract-plugin
export default {"top":"style_top__QIzzK","profile":"style_profile__f6I1b","image":"style_image__WuKYX","name":"style_name__NiUyJ","Shouts":"style_Shouts__9M1w-"};